import React, { useContext, useState } from "react"
import styles from "./ContentConfirmation.module.css"
import { labelMap } from "./constants"
import { StepContext } from "../../StepContainer"
import { RenderValueFunction } from "./types"

export const BasicInformation = () => {
    const { displayState } = useContext(StepContext)
    const [showPassword, setShowPassword] = useState(false)

    const filteredDisplayState = Object.entries(displayState).filter(([key]) =>
        Object.keys(labelMap).includes(key)
    )

    const renderValue: RenderValueFunction = (key, value) => {
        if (key === "password") {
            return showPassword ? value : "●".repeat(8)
        }
        return value || ""
    }

    return (
        <div className={styles.accordionContentInner}>
            <div className={styles.infoGroup}>
                <h3>基本情報</h3>
                {filteredDisplayState.map(([key, value]) => (
                    <div key={key} className={styles.infoRow}>
                        <span className={styles.infoLabel}>
                            {labelMap[key]}
                        </span>
                        <span
                            className={`${styles.infoValue} ${styles.text_linefeed}`}
                        >
                            {renderValue(key, value)}
                        </span>
                    </div>
                ))}
                <div className={styles.checkboxWrapper}>
                    <input
                        type="checkbox"
                        id="passwordToggle"
                        className={styles.customCheckbox}
                        checked={showPassword}
                        onChange={e => setShowPassword(e.target.checked)}
                    />
                    <label htmlFor="passwordToggle">パスワードを表示する</label>
                </div>
            </div>
        </div>
    )
}
